import Vue from "vue";
import Router from "vue-router";
import Profile from "./views/Profile.vue";
import Callback from "./components/Callback.vue";
import EnhancementNew from "./components/Page/EnhancementNew.vue";
import EnhancementSubmitted from "./components/Page/EnhancementSubmitted.vue";
import EnhancementStatus from "./components/Page/EnhancementStatus.vue";
import Home from "./components/Page/Home.vue";
import Title from "./components/Layout/PageTitle";
import auth from "./auth/authService";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        pageHeader: Title,
        pageContent: Home
      },
      props: { pageHeader: { title: "Home", subtitle: "" } }
    },
    {
      path: "/profile",
      name: "profile",
      components: {
        pageHeader: Title,
        pageContent: Profile
      },
      props: { pageHeader: { title: "Profile Data", subtitle: "" } }
    },
    {
      path: "/callback",
      name: "callback",
      components: {
        pageHeader: Title,
        pageContent: Callback
      },
      props: {
        pageHeader: { title: "Request Status", subtitle: "" }
      }
    },
    {
      path: "/enhancement/add",
      name: "enhancement-add",
      components: {
        pageHeader: Title,
        pageContent: EnhancementNew
      },
      props: { pageHeader: { title: "New Request", subtitle: "" } }
    },
    {
      path: "/enhancement/submitted",
      name: "enhancement-submitted",
      components: {
        pageHeader: Title,
        pageContent: EnhancementSubmitted
      },
      props: { pageHeader: { title: "New Request", subtitle: "" } }
    },
    {
      path: "/enhancement/status",
      name: "enhancement-status",
      components: {
        pageHeader: Title,
        pageContent: EnhancementStatus
      },
      props: {
        pageHeader: { title: "Request Status", subtitle: "" }
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path === "/callback" || auth.isAuthenticated()) {
    return next();
  }

  auth.login({ target: "/enhancement/status" });
});

export default router;
